import create from "zustand";

interface LoginModalState {
  isOpen: boolean;
}

interface LoginModalActions {
  onOpen: () => void;
  onClose: () => void;
}

const useLoginModal = create<LoginModalState & LoginModalActions>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useLoginModal;
